import LeaderboardList from './LeaderboardList';
import SeeMore from '../SeeMore';
import Popover from '@/external/components/Popover';
import { TournamentFragment } from '@/shared/graphql/TournamentFragment.generated';

type Props = {
  tournament?: TournamentFragment;
  translations: Record<string, string>;
  isBitcasino: boolean;
};

const PopoverLeaderboard: React.FC<Props> = ({
  tournament,
  translations,
  isBitcasino,
}) => (
  <Popover>
    <Popover.Trigger>
      <SeeMore />
    </Popover.Trigger>
    <Popover.Panel className="absolute !-top-[7.5rem] w-[13.25rem] bg-gohan p-4">
      <LeaderboardList
        tournament={tournament}
        translations={translations}
        isBitcasino={isBitcasino}
      />
    </Popover.Panel>
  </Popover>
);

export default PopoverLeaderboard;
